import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useLaboratories () {
  return useQuery('laboratories', async () => {
    const laboratories = await axios.get(`${getApiServer()}/laboratories`)
    return laboratories.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}